import {
    SET_COST_CENTER,
} from "./CostCenterType";

const initialState = {
    costCenterDropDown: []
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_COST_CENTER:
            return {
                ...state,
                costCenterDropDown: action.assetType,
            };
        default:
            return state;
    }
};

export default reducer;
